export class DomUtil {

    public static generateElementId(length: number = 5): string {
        const alphabet = "0123456789abcdefghiklmnopqrstuvwxyz".split("");

        let str = "";
        for (let i = 0; i < length; i++) {
            str += alphabet[Math.floor(Math.random() * alphabet.length)];
        }
        return `pb-${str}`;
    }

    public static deleteAllChildElements(domNode: HTMLElement): void {
        while (domNode.firstChild) {
            domNode.removeChild(domNode.firstChild);
        }
    }

}
